// Configuration des URLs d'API selon l'environnement
const API_CONFIG = {
  development: {
    baseURL: '', // les appels incluent déjà /api (proxy de vue.config.js)
  },
  production: {
    baseURL: '', // les appels incluent déjà /api (proxy nginx)
  }
}

const environment = process.env.NODE_ENV || 'development'
export const apiConfig = API_CONFIG[environment]

// Configuration axios par défaut
import axios from 'axios'

axios.defaults.baseURL = apiConfig.baseURL
axios.defaults.timeout = 10000

// Intercepteur pour gérer les erreurs globalement
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.status, error.response?.data)
    if (error.response?.status === 401) {
      // Rediriger vers la page de connexion si non authentifié
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default axios